import { PermissionCheckerService, FeatureCheckerService } from 'abp-ng2-module';
import { AppSessionService } from '@shared/common/session/app-session.service';

import { Injectable } from '@angular/core';
import { AppMenu } from './app-menu';
import { AppMenuItem } from './app-menu-item';
import { AnnouncementService } from '../topbar/announcement.service';


@Injectable()
export class AppNavigationService {

    constructor(
        private _permissionCheckerService: PermissionCheckerService,
        private _appSessionService: AppSessionService,
        private _featureCheckerService: FeatureCheckerService,
        private _announcementService: AnnouncementService
    ) { }

    getMenu(): AppMenu {
        return new AppMenu('MainMenu', 'MainMenu', [
            new AppMenuItem('Dashboard', 'Pages.Administration.Host.Dashboard', 'flaticon-line-graph', '/app/admin/hostDashboard'),
            new AppMenuItem('Dashboard', 'Pages.Tenant.Dashboard', 'flaticon-line-graph', '/app/main/dashboard'),
            new AppMenuItem('Tenants', 'Pages.Tenants', 'flaticon-list-3', '/app/admin/tenants'),
            new AppMenuItem('Editions', 'Pages.Editions', 'flaticon-app', '/app/admin/editions'),
            new AppMenuItem('Exchange Rate', 'Pages.PaymentGateway.Admin.GetCurrencyExchangeRate', 'flaticon2-list', '/app/admin/exchangeRate'),
            new AppMenuItem('Administration', '', 'flaticon-interface-8', '', [], [
                new AppMenuItem('Announcement Settings', 'Pages.PaymentGateway.Admin.AddOrEditAnnouncement', 'flaticon2-speaker', '/app/admin/announcement-settings'),
                new AppMenuItem('Channel Maintenance Settings', 'Pages.PaymentGateway.Admin.GetChannelMaintenanceSettings', 'flaticon-lock', '/app/admin/channel-maintenance-settings'),
                new AppMenuItem('OrganizationUnits', 'Pages.Administration.OrganizationUnits', 'flaticon-map', '/app/admin/organization-units'),
                new AppMenuItem('Roles', 'Pages.Administration.Roles', 'flaticon-suitcase', '/app/admin/roles'),
                new AppMenuItem('Users', 'Pages.Administration.Users', 'flaticon-users', '/app/admin/users'),
                new AppMenuItem('Languages', 'Pages.Administration.Languages', 'flaticon-tabs', '/app/admin/languages', ['/app/admin/languages/{name}/texts']),
                new AppMenuItem('AuditLogs', 'Pages.Administration.AuditLogs', 'flaticon-folder-1', '/app/admin/auditLogs'),
                new AppMenuItem('Maintenance', 'Pages.Administration.Host.Maintenance', 'flaticon-lock', '/app/admin/maintenance'),
                new AppMenuItem('Subscription', 'Pages.Administration.Tenant.SubscriptionManagement', 'flaticon-refresh', '/app/admin/subscription-management'),
                new AppMenuItem('VisualSettings', 'Pages.Administration.UiCustomization', 'flaticon-medical', '/app/admin/ui-customization'),
                new AppMenuItem('WebhookSubscriptions', 'Pages.Administration.WebhookSubscription', 'flaticon2-world', '/app/admin/webhook-subscriptions'),
                new AppMenuItem('DynamicParameters', '', 'flaticon-interface-8', '', [], [
                    new AppMenuItem('Definitions', 'Pages.Administration.DynamicParameters', '', '/app/admin/dynamic-parameter'),
                    new AppMenuItem('EntityDynamicParameters', 'Pages.Administration.EntityDynamicParameters', '', '/app/admin/entity-dynamic-parameter'),
                ]),
                new AppMenuItem('Settings', 'Pages.Administration.Host.Settings', 'flaticon-settings', '/app/admin/hostSettings'),
                new AppMenuItem('DashboardSettings', 'Pages.Administration.Host.DashboardSettings', 'flaticon-dashboard', '/app/admin/dashboard-settings'),
                new AppMenuItem('Settings', 'Pages.Administration.Tenant.Settings', 'flaticon-settings', '/app/admin/tenantSettings')
            ]),
            new AppMenuItem('Payment Gateway', '', 'flaticon-coins', '', [], [
                new AppMenuItem('Merchant Reports', 'Pages.PaymentGateway.TransactionReport', 'flaticon-interface-11', '/app/paymentgateway/transactionreport'), 
                new AppMenuItem('Transaction History', 'Pages.PaymentGateway.TransactionHistory', 'flaticon-clock', '/app/paymentgateway/transactionhistory'),
                new AppMenuItem('Suspicious Transaction', 'Pages.PaymentGateway.Admin.GetSuspiciousTransaction', 'flaticon-file', '', [], [
                    new AppMenuItem('New', 'Pages.PaymentGateway.Admin.GetSuspiciousTransaction', '', '/app/paymentgateway/suspicioustrans/0'),
                    new AppMenuItem('Pending', 'Pages.PaymentGateway.Admin.GetSuspiciousTransaction', '', '/app/paymentgateway/suspicioustrans/3'),
                    new AppMenuItem('Reject', 'Pages.PaymentGateway.Admin.GetSuspiciousTransaction', '', '/app/paymentgateway/suspicioustrans/2'),
                    new AppMenuItem('Approve', 'Pages.PaymentGateway.Admin.GetSuspiciousTransaction', '', '/app/paymentgateway/suspicioustrans/1'),
                ]),
                new AppMenuItem('Transaction Limit Monitor', 'Pages.PaymentGateway.Admin.TransactionLimitMonitor', 'flaticon-warning-sign', '', [], [
                    new AppMenuItem('Dashboard', 'Pages.PaymentGateway.Admin.TransactionLimitMonitor.Dashboard', '', '/app/paymentgateway/transactionlimitmonitor/dashboard'),
                    new AppMenuItem('Logs', 'Pages.PaymentGateway.Admin.TransactionLimitMonitor.Logs', '', '/app/paymentgateway/transactionlimitmonitor/logs'),
                ]),
                new AppMenuItem('Manual Refund', 'Pages.PaymentGateway.RefundQuery', 'fas fa-hand-holding-usd', '/app/paymentgateway/manualrefund'), 
                new AppMenuItem('Settlement', 'Pages.PaymentGateway.Admin.GetUnsettledSettlementTransactionList', 'far fa-handshake', '', [], [
                    new AppMenuItem('Unsettled', 'Pages.PaymentGateway.Admin.GetUnsettledSettlementTransactionList', '', '/app/paymentgateway/unsettledtransactions'),
                    new AppMenuItem('Inprogress', 'Pages.PaymentGateway.Admin.GetSettlementRecords', '', '/app/paymentgateway/draftsettlement/2'),
                    new AppMenuItem('Complete', 'Pages.PaymentGateway.Admin.GetSettlementRecords', '', '/app/paymentgateway/draftsettlement/1'),
                    new AppMenuItem('Lock/Unlock Transaction', 'Pages.PaymentGateway.Admin.LockedTransactions', '', '/app/paymentgateway/lockedtransaction'),
                    new AppMenuItem('Provider Fee Adjustment', 'Pages.PaymentGateway.Admin.ProviderReport', '', '/app/paymentgateway/providerfeeadjustment'),
                ]),
                new AppMenuItem('Dispute History', 'Pages.PaymentGateway.Admin.GetPaymentDisputeList', 'flaticon-list', '/app/paymentgateway/disputehistory'),
                new AppMenuItem('Search by Approval Code', 'Pages.PaymentGateway.Admin.SearchByApprovalCode', 'flaticon-search-1', '/app/paymentgateway/approvalcodesearch'),
                new AppMenuItem('Virtual Account', 'Pages.CATenant.VirtualAccount.Tenant.GetRequestApplications', 'flaticon-network', '', [], [
                    new AppMenuItem('Application Lists', 'Pages.CATenant.VirtualAccount.Tenant.GetRequestApplications', '', '/app/paymentgateway/virtualapplications'),
                    new AppMenuItem('Virtual Account User List', 'Pages.CATenant.VirtualAccount.Tenant.GetTenantVirtualAccountUsers', '', '/app/paymentgateway/vauserlist'),
                    
                ], undefined, undefined, () => {
                    return this._featureCheckerService.isEnabled('App.TenantVirtualAccountFeature');
                }),
                new AppMenuItem('Request Payment', 'Pages.PaymentGateway.RequestPayment', 'far fa-file-code', '/app/paymentgateway/requestpayment', [], [], undefined, undefined, () => {
                    return this._appSessionService.checkIsHost;
                }),
                new AppMenuItem('Payment Link', 'Pages.PaymentGateway.RequestPayment', 'far fa-file-code', '/app/paymentgateway/paymentlink', [], [], undefined, undefined, () => {
                    return !this._appSessionService.checkIsHost;
                }),
                new AppMenuItem('Payment Form', 'Pages.PaymentForm', 'flaticon2-expand', '/app/paymentgateway/paymentForm', [], [], undefined, undefined, () => {
                    return this._featureCheckerService.isEnabled('App.PaymentFormFeature') || this._featureCheckerService.isEnabled('App.SubscriptionFormFeature');
                }),
                new AppMenuItem('IPP Offline QR', '', 'fas fa-qrcode', '/app/paymentgateway/ipp-offline-qr', [], [], undefined, undefined, () => {
                    return this._featureCheckerService.isEnabled('App.IPPOfflineQRFeature');
                }),
                new AppMenuItem('PayPal Onboarding', 'Pages.PaymentGateway.LinkOnboardingProvider', 'fa fa-link', '/app/paymentgateway/provider-onboarding'),
                // Merchant side of the two tier channel switch. Hidden from the host, whose own
                // controls live under Settings > Master Channels and Tenant Channels.
                new AppMenuItem('Payment Channels', 'Pages.PaymentGateway.Tenant.PaymentChannel', 'flaticon-list-1', '/app/paymentgateway/paymentchannels', [], [], undefined, undefined, () => {
                    return !this._appSessionService.checkIsHost;
                }),
                new AppMenuItem('Settings', '', 'flaticon-cogwheel', '', [], [
                    new AppMenuItem('Master Channels', 'Pages.PaymentGateway.Admin.ViewMasterChannel', '', '/app/paymentgateway/channelssetting'),
                    new AppMenuItem('Tenant Channels', 'Pages.PaymentGateway.Admin.GetAllTenantWithPaymentGatewayFeature', '', '/app/paymentgateway/tenantlist'),
                    new AppMenuItem('Reseller Channels', 'Pages.PaymentGateway.Admin.GetResellerChannelCommission', '', '/app/paymentgateway/resellerchannels'),
                    new AppMenuItem('Reserve Setting', 'Pages.PaymentGateway.Admin.GetChannelReserveSetting', '', '/app/paymentgateway/reservesetting'),
                    new AppMenuItem('Transaction Limit', 'Pages.PaymentGateway.Admin.TransactionLimitSetting', '', '/app/paymentgateway/transactionlimit'),
                    new AppMenuItem('Settlement', 'Pages.PaymentGateway.Admin.GetTenantSettlementSettings', '', '/app/paymentgateway/settlementsetting'),
                    new AppMenuItem('Automate Setting', 'Pages.PaymentGateway.Admin.GetAutomateSetting', '', '/app/paymentgateway/automatesetting'),
                    new AppMenuItem('Tenant Platforms','Pages.CATenant.Admin.AddOrEditTenantPlatform', '', '/app/paymentgateway/tenantplatformssetting'),
                    new AppMenuItem('Tenant Configuration','Pages.CATenant.Admin.AddOrEditTenantPlatform', '', '/app/paymentgateway/tenantconfiguration'),
                    new AppMenuItem('Loyalty Providers','Pages.LoyaltyPayment.Admin.AddOrEditLoyaltyProvider', '', '/app/paymentgateway/loyaltyprovider'),
                    new AppMenuItem('AutoCount Mapping', 'Pages.PaymentGateway.Admin.GetTenantFinAccountMapped', '', '/app/paymentgateway/financeaccountmapping'),
                ]),
                new AppMenuItem('Loyalty Settings', 'Pages.LoyaltyPayment.Tenant.AddOrEditTenantLoyaltySetting', 'far fa-file-code', '/app/paymentgateway/loyaltysettings', [], [], undefined, undefined, () => {
                    return this._featureCheckerService.isEnabled('App.LoyaltyPaymentFeature');
                }),
                new AppMenuItem('Transaction Limit', 'Pages.PaymentGateway.TransactionLimitSetting.View', 'flaticon-warning-sign', '/app/paymentgateway/transactionlimitsetting'),
                new AppMenuItem('Revoke Token', 'Pages.PaymentGateway.Admin.RevokeTokenize', 'fas fa-unlock-alt', '/app/paymentgateway/revokeToken'),
                new AppMenuItem('Wallet', 'Pages.Tenant.Wallet', 'pi pi-wallet', '', [], [
                    // balance & payout
                    new AppMenuItem('Balance', '', '', '/app/paymentgateway/wallet/balance'),
                    // new AppMenuItem('Payout', '', '', '/app/paymentgateway/wallet/payout')
                    // Host-wide request list — GetManualTopupRequestApplications now returns both
                    // top up and deduct requests together, so this one item covers both. Gated by
                    // the general "view" permission so any host who can view requests sees this
                    // item; the page itself still gates the actual Approve/Reject buttons behind
                    // ManualWalletApproval separately.
                    new AppMenuItem('Top Up / Deduct Requests', 'Pages.Tenant.WalletTopup.TopUpDeductRequest', '', '/app/paymentgateway/wallet/manualwalletapproval'),
                ], undefined, undefined, () => {
                    return this._featureCheckerService.isEnabled('App.TenantWalletFeature');
                }),
                new AppMenuItem('Signature Validator', '', 'far fa-file-code', '/app/paymentgateway/signaturevalidator')
            ], undefined, undefined, () => {
                return this._featureCheckerService.isEnabled('App.PaymentGatewayFeature');
            }),
            new AppMenuItem('Reseller', 'Pages.Reseller', 'fa fa-users', '', [], [
                new AppMenuItem('Reseller Reports', 'Pages.Reseller.Admin.ExportResellerChargeTransactionHistory', 'flaticon-interface-11', '/app/paymentgateway/reseller/transactionreport'),
                new AppMenuItem('Transaction History', 'Pages.Reseller.Admin.ResellerTransactionHistory', 'flaticon-clock', '/app/paymentgateway/reseller/transactionhistory'),
                new AppMenuItem('Submerchant Reports', 'Pages.Reseller.Tenant.SubMerchatJobList', 'flaticon-file-2', '/app/paymentgateway/reseller/transactionsubmerchantreport'),
            ], undefined, undefined, () => {
                return this._featureCheckerService.isEnabled('App.ResellerSettingFeature');
            }),
            new AppMenuItem('Merchant Profile', 'Pages.CATenant.ViewProfile', 'fas fa-user-tag', '/app/paymentgateway/tenantprofile'),
            new AppMenuItem('Host Profile', 'Pages.PaymentGateway.Admin.GetAllTenantWithPaymentGatewayFeature', 'flaticon-profile', '/app/paymentgateway/hostprofile'),
            new AppMenuItem('DemoUiComponents', 'Pages.DemoUiComponents', 'flaticon-shapes', '/app/admin/demo-ui-components'),
            (() => {
                const item = new AppMenuItem('Announcements', '', 'flaticon2-speaker icon-blue-blink', '');
                item.action = () => this._announcementService.show();
                return item;
            })(),
            
        ]);
    }

    checkChildMenuItemPermission(menuItem): boolean {

        for (let i = 0; i < menuItem.items.length; i++) {
            let subMenuItem = menuItem.items[i];

            if (subMenuItem.permissionName === '' || subMenuItem.permissionName === null) {
                if (subMenuItem.route) {
                    return true;
                }
            } else if (this._permissionCheckerService.isGranted(subMenuItem.permissionName)) {
                return true;
            }

            if (subMenuItem.items && subMenuItem.items.length) {
                let isAnyChildItemActive = this.checkChildMenuItemPermission(subMenuItem);
                if (isAnyChildItemActive) {
                    return true;
                }
            }
        }
        return false;
    }

    showMenuItem(menuItem: AppMenuItem): boolean {
        if (menuItem.route === '/app/paymentgateway/requestpayment' && this._appSessionService.tenant) {
            return false;
        }

        if (menuItem.route === '/app/paymentgateway/paymentlink' && !this._appSessionService.tenant) {
            return false;
        }

        if (menuItem.route === '/app/paymentgateway/ipp-offline-qr') {
            if (!this._appSessionService.tenant) {
                return false;
            }

            if (!this._featureCheckerService.isEnabled('App.IPPOfflineQRFeature')) {
                return false;
            }
        }

        if (menuItem.permissionName === 'Pages.Administration.Tenant.SubscriptionManagement' && this._appSessionService.tenant && !this._appSessionService.tenant.edition) {
            return false;
        }

        let hideMenuItem = false;

        if (menuItem.requiresAuthentication && !this._appSessionService.user) {
            hideMenuItem = true;
        }

        if (menuItem.permissionName && !this._permissionCheckerService.isGranted(menuItem.permissionName)) {
            hideMenuItem = true;
        }

        if (this._appSessionService.tenant || !abp.multiTenancy.ignoreFeatureCheckForHostUsers) {
            if (menuItem.hasFeatureDependency() && !menuItem.featureDependencySatisfied()) {
                hideMenuItem = true;
            }
        }

        if (!hideMenuItem && menuItem.items && menuItem.items.length) {
            return this.checkChildMenuItemPermission(menuItem);
        }

        return !hideMenuItem;
    }

    /**
     * Returns all menu items recursively
     */
    getAllMenuItems(): AppMenuItem[] {
        let menu = this.getMenu();
        let allMenuItems: AppMenuItem[] = [];
        menu.items.forEach(menuItem => {
            allMenuItems = allMenuItems.concat(this.getAllMenuItemsRecursive(menuItem));
        });

        return allMenuItems;
    }

    private getAllMenuItemsRecursive(menuItem: AppMenuItem): AppMenuItem[] {
        if (!menuItem.items) {
            return [menuItem];
        }

        let menuItems = [menuItem];
        menuItem.items.forEach(subMenu => {
            menuItems = menuItems.concat(this.getAllMenuItemsRecursive(subMenu));
        });

        return menuItems;
    }
}
